import React from 'react';
import { categories } from '../mock';
import * as Icons from 'lucide-react';
import { Button } from './ui/button';

const CategoryFilter = ({ selectedCategory, onSelectCategory }) => {
  return (
    <div className="bg-white border-b shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center space-x-2 overflow-x-auto scrollbar-hide">
          <Button
            variant={!selectedCategory ? 'default' : 'outline'}
            onClick={() => onSelectCategory(null)}
            className={`whitespace-nowrap ${
              !selectedCategory ? 'bg-red-500 hover:bg-red-600 text-white' : ''
            }`}
          >
            All
          </Button>
          {categories.map((category) => {
            const Icon = Icons[category.icon];
            return (
              <Button
                key={category.id}
                variant={selectedCategory === category.id ? 'default' : 'outline'}
                onClick={() => onSelectCategory(category.id)}
                className={`whitespace-nowrap flex items-center space-x-2 ${
                  selectedCategory === category.id
                    ? 'bg-red-500 hover:bg-red-600 text-white'
                    : ''
                }`}
              >
                {Icon && <Icon className="w-4 h-4" />}
                <span>{category.name}</span>
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;
